import { FE_PHASE_OUT_SERIALIZED_INSIDER_MEMBERSHIP_INFORMATION_250224 } from "@faire/retailer-settings/FE_PHASE_OUT_SERIALIZED_INSIDER_MEMBERSHIP_INFORMATION_250224";
import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingPhaseOutSerializedInsiderMembership = (): boolean =>
  useSetting(FE_PHASE_OUT_SERIALIZED_INSIDER_MEMBERSHIP_INFORMATION_250224);
